import React from 'react';

import { UIText3 } from '@cian/ui-kit';
import styles from './styles.css';

export interface IAdvertiserProps {
  aboutAdvertiser?: string;
}
//TODO пересобрать при рефакторинге
export const Advertiser: React.FC<IAdvertiserProps> = ({ aboutAdvertiser }) => {
  if (!aboutAdvertiser) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <UIText3 color={'current_color'}>{aboutAdvertiser}</UIText3>
    </div>
  );
};
